import VueCookies from 'vue-cookies';
import RefappGeoipRedirect from './components/refapp-geoip-redirect.vue';
import RefappGeoipOption from './components/base/refapp-geoip.vue';

export default {
  install(app) {
    const components = [RefappGeoipRedirect, RefappGeoipOption];
    if (!app.$cookies) app.use(VueCookies);
    components.forEach((c) => app.component(c.name, c));
  },
};
